// extracted by mini-css-extract-plugin
export default {"tweet":"Tweet_tweet__5uJn3","header":"Tweet_header__-WnZF","profile":"Tweet_profile__bxb9o","img-span":"Tweet_img-span__ErFEr","img":"Tweet_img__xRi9B","btn":"Tweet_btn__XJ2ZI"};